<template>
  <v-dialog v-if="maintenanceMode" :model-value="true" fullscreen persistent :opacity="1">
    <v-card v-if="maintenanceRedirection" class="pa-6 d-block">Your account has been transfered. Please connect on <a :href="maintenanceRedirection">{{ maintenanceRedirection }}</a>.</v-card>
    <v-card v-else class="pa-6">Your account is currently in maintenance mode. Please try again later.</v-card>
  </v-dialog>
  <v-dialog v-else-if="displayPremiumSuspended" :model-value="!! displayPremiumSuspended" width="100%" height="100%" persistent :opacity=".8">
    <v-card class="premium-subscription-scroll-container h-100 pa-6 bg-background light-scrollbar">
      <premium-subscription></premium-subscription>
    </v-card>
  </v-dialog>
  <v-app-bar v-else-if="displayPremiumExpired" flat color="background">
    <v-alert type="error" prominent :height="60" :rounded="0" class="px-12 py-0 align-self-start">
      {{ $t('PREMIUM.SUSPENDED.ACCOUNT_EXPIRED_SINCE') }} {{ $filters.moment(premiumExpireDate, 'date') }}. {{ $t('PREMIUM.SUSPENDED.ACCOUNT_WILL_BE_SUSPENDED') }}
    </v-alert>
  </v-app-bar>
</template>

<script>
  import useUiModalsStore from '@/stores/ui/modals';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import PremiumSubscription from './PremiumSubscription';

  export default {
    components: {
      PremiumSubscription,
    },
    data() {
      return {
        premiumExpireDate: null,
        uiModalsStore: useUiModalsStore(),
        usersStore: useUsersStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      displayPremiumSuspended() {
        return this.uiModalsStore.displayPremiumSuspended;
      },
      displayPremiumExpired() {
        return this.uiModalsStore.displayPremiumExpired;
      },
      isTrial() { return this.usersAccessRightStore.isTrial; },
      maintenanceMode() { return this.usersAccessRightStore.maintenanceMode; },
      maintenanceRedirection() { return typeof this.maintenanceMode == 'string' && `https://${this.maintenanceMode}.bubbleplan.net`; },
    },
    created() {
      this.usersStore.userPromise.then(() => {
        const { user } = this.usersStore;
        this.premiumExpireDate = user.company && user.company.premiumExpireDate;
      });
    },
  };
</script>
